import { useCallback, useState } from 'react'

import { useQueryStatusQuery } from 'features/agent_hub/graphql_api'

/**
 * Custom hook for managing query status polling using RTK Query's built-in polling
 * Handles starting, stopping, and managing polling for query status updates
 */
export const useQueryPolling = () => {
  const [queryId, setQueryId] = useState(null)
  const [isPolling, setIsPolling] = useState(false)

  // Use RTK Query's built-in polling with conditional fetching
  const {
    data: queryStatusData,
    error: queryStatusError
  } = useQueryStatusQuery(
    { queryId },
    {
      skip: !queryId || !isPolling,
      pollingInterval: isPolling ? 300 : 0,
    }
  )

  const stopPolling = useCallback(() => {
    setIsPolling(false)
  }, [])

  const startPolling = useCallback((newQueryId) => {
    setQueryId(newQueryId)
    setIsPolling(true)
  }, [])

  return {
    queryStatusData,
    queryStatusError,
    startPolling,
    stopPolling,
    isPolling
  }
}
